import React from 'react';

const ActiveTextIndicator = ({ initialValue }) => {

    return (
        <h6>{initialValue ? "Activo" : "Inactivo"}</h6>
    )
}

export default ActiveTextIndicator;